var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.75 9.75C32.25 9.75 9.75 32.25 9.75 59.75C9.75 87.25 32.25 109.75 59.75 109.75C87.25 109.75 109.75 87.25 109.75 59.75C109.75 32.25 87.25 9.75 59.75 9.75ZM59.75 99.75C37.7 99.75 19.75 81.8 19.75 59.75C19.75 37.7 37.7 19.75 59.75 19.75C81.8 19.75 99.75 37.7 99.75 59.75C99.75 81.8 81.8 99.75 59.75 99.75ZM82.7 37.65L49.75 70.6L36.8 57.7L29.75 64.75L49.75 84.75L89.75 44.75L82.7 37.65Z",
    fill: "#94E21D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.7583a9386332e58cc2dc918930340129.svg";
export { ForwardRef as ReactComponent };